import styled, { css } from "styled-components";

import { DESKTOP_BREAKPOINT } from "../../../../components/AppShell/styles";
import { Box } from "../../../../components/Layout";

/* At least one screen tall, so the fixed bar sits at the bottom (as StickyBarPage) */
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100dvh - var(--app-bottom-nav-height, 0px));
`;

/* The groups of the screen, one under the other (Temas prontos, Fundo, Botões, Texto, Rodapé) */
export const Groups = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  /* the groups' titles and Alinhamento's: the line as tall as the letters, as the fields' labels */
  h5 {
    line-height: 1;
  }
`;

/* Rodapé: the brand's switch, with what it does beside it */
export const FooterRow = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
  font-family: "Inter", sans-serif;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--color-neutral-white);

  /* the switch as tall as itself, without its usual space under it, so it lines up with the text */
  label {
    height: 24px;
    margin-bottom: 0;
  }
`;

/* The screen's content, with the same vertical spacing as the sections list */
export const ContentBox = styled(Box)`
  /* Bottom: the fixed bar's own spacer keeps the distance */
  padding-top: 1.5rem;
  padding-bottom: 0;

  @media not all and (min-width: ${DESKTOP_BREAKPOINT}) {
    padding-top: 20px;
  }
`;

/* A line between the blocks of a group (e.g. Fontes: alignment, titles, texts) */
export const Divider = styled.hr`
  width: 100%;
  margin: 0;
  border: 0;
  border-top: 1px solid var(--color-neutral-base);
`;

/* The label over a field of a group (Alinhamento's look): small capitals, the line as tall as the letters (no
   extra space above or below to throw it off) */
export const fieldLabel = css`
  color: var(--color-neutral-light);
  font-family: Inter, sans-serif;
  font-size: 0.625rem;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.5px;
  text-transform: uppercase;
`;

/* Fundo › Cor: the ready-made themes under their label */
export const ThemesField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;

  .role {
    ${fieldLabel}
  }
`;

/* A line saying why there's nothing to choose here (e.g. Vidro paints with the page's text color) */
export const Note = styled.p`
  margin: 0;
  font-family: Inter, sans-serif;
  font-size: 0.8125rem;
  line-height: 1.125rem;
  color: #a3a8ba;
`;

/* Why going on failed, in the fixed bar over its button */
export const SaveError = styled.p`
  margin: 0 0 0.75rem;
  font-family: Inter, sans-serif;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: var(--color-feedback-danger);
`;

/* The way back from publishing without PLUS: the PLUS offer, and the button to the simple version under it */
export const PlusRequiredNotice = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
`;
